import { atom } from 'jotai';
export const $UserAgent = atom({
    isMobile: false,
    isBot: false,
    isiOS: false,
    isSafari: false,
    isInApp: false,
    isMacOS: false,
});
//# sourceMappingURL=user-agent.js.map